import { gql } from 'graphql-request'

export const GET_MY_SHELF = gql`
  query GetMyShelf(
    $limitPerPage: Int
    $page: Int
    $bookType: [BookType!]
    $chapterType: ChapterType
    $categoryIds: [Int!]
    $shelfBookDisplay: ShelfBookDisplay
    $shelfBookOrder: ShelfBookOrder
    $searchText: String
    $isEbook: Boolean
  ) {
    getMyShelf(
      limitPerPage: $limitPerPage
      page: $page
      bookType: $bookType
      chapterType: $chapterType
      categoryIds: $categoryIds
      shelfBookDisplay: $shelfBookDisplay
      shelfBookOrder: $shelfBookOrder
      searchText: $searchText
      isEbook: $isEbook
    ) {
      data {
        book {
          id
          title
          isEnded
          isEbook
          writer
          penName {
            firstPenName
            user {
              id
              writer {
                affiliation
              }
              displayName
              profilePageSlug
            }
          }
          tags {
            name
            id
          }
          category {
            id
            name
          }
          hasSalePromotions
          buyAllChaptersPromotion {
            startDate
            endDate
            discountType
            discountPercentage
          }
          readFreePromotion {
            startedAt
            endedAt
          }
          bookBadges {
            badgeCategoryId
            badgeImageUrl
          }
          bookChapterCampaignHeader {
            minSellingPrice
            totalChapter
            startedAt
            endedAt
          }
          coverImgPath
          coverResizeImgPath
          cover
          bookType
          likeCount
          commentCount
          viewCount
          isLiked
          isTranslated
          bookChapters {
            id
            chapterName
          }
          publishedChapterCount
        }
      }
      total
      page
    }
  }
`
